module.exports = __webpack_public_path__ + "img/partner_ny_03@2x.34868483.png";